import React from 'react';
import NotificationsActiveOutlined from "@material-ui/icons/NotificationsActiveOutlined";
// import SystemIcon from '../../components/ShortStatus/SystemIcon';
import Card from '../../../components/Card/CardTS';
import CardBody from '../../../components/Card/CardBody';
import CardHeader from '../../../components/Card/CardHeaderTS';
import CardIcon from '../../../components/Card/CardIcon';
import GridItem from '../../../components/Grid/GridItem';
import GridContainer from '../../../components/Grid/GridContainer';
import ErrorComponent from '../../components/ErrorComponent/ErrorComponent';
import QRCode from "react-qr-code";
import { Button } from '@material-ui/core';
const headerTextColor = '#3C4858';
const QRColor = 'rgb(60, 72, 88)';

interface RegisterInMobileAppProps {
    accountQRCode: string;
}

const RegisterInMobileApp = ({
    accountQRCode
}: RegisterInMobileAppProps) => {
    return (
        <ErrorComponent message='QR code crashed' Children>
            <GridItem xs={12}>
                <Card className='QRCode'>
                    <CardHeader color='info' icon>
                        <CardIcon color='info'>
                            <NotificationsActiveOutlined />
                        </CardIcon>
                        <h4 style={{ color: headerTextColor }}>
                            Register in WISENE Watch
                        </h4>
                    </CardHeader>
                    <CardBody style={{ textAlign: 'center', marginBottom: '0px', paddingBottom: '0px' }}>
                        <p>
                            Scan with <a href="https://play.google.com/store/apps/details?id=com.wisene.wisene_watch"> WISENE Watch </a> to receive push notifications
                        </p>
                         <QRCode
                            fgColor={QRColor}
                            value={accountQRCode}
                            level={'L'}
                            size={100}

                        />
                    </CardBody>
                    <CardBody style={{ textAlign: 'center', marginTop: '0px', paddingTop: '0px', paddingBottom: '0px' }}>
                        <Button style={{userSelect: 'all', textTransform: 'none'}} onClick={async () => await navigator.clipboard.writeText(accountQRCode)}>
                        <i className="fas fa-copy fa-regular" style={{paddingRight: '10px'}} />  {accountQRCode}
                        </Button>
                    </CardBody>
                </Card>
            </GridItem>
        </ErrorComponent >
    );
};


export default RegisterInMobileApp;
